import React, { useState } from "react";
import Breadcrumb from "../components/elements/Breadcrumb";
import Head from "next/head";
import { toast } from "react-toastify";

const Contact = () => {
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const promise = new Promise((resolve, reject) =>
      fetch("/api/mail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValues),
      }).then((res) => {
        if (res.status === 201) {
          setFormValues({
            name: "",
            email: "",
            message: "",
          });
          return resolve(res);
        } else {
          return reject(res);
        }
      })
    );

    toast.promise(promise, {
      pending: "Email verzenden...",
      success: "Email succesvol verzonden!",
      error: "Er is een fout opgetreden, probeer het later opnieuw!",
    });
  };
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <link rel="shortcut icon" type="image/png" href="/assets/imgs/logos/favicon.png"/>
        <link rel="apple-touch-icon" href="/assets/imgs/logos/app/apple-touch-icon.png"/>
        <link
            rel="apple-touch-icon"
            sizes="48x48"
            href="/assets/imgs/logos/app/x48.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="72x72"
            href="/assets/imgs/logos/app/x72.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="96x96"
            href="/assets/imgs/logos/app/x96.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="144x144"
            href="/assets/imgs/logos/app/x144.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="168x168"
            href="/assets/imgs/logos/app/x168.png"
        />
        <link
            rel="apple-touch-icon"
            sizes="192x192"
            href="/assets/imgs/logos/app/x192.png"
        />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="author" content="ANIVIA" />
        <meta name="theme-color" content="#007aff" />
        <link rel="manifest" href="/manifest.json" />
        <meta
          name="description"
          content="ANIVIA te Heusden-Zolder helpt je met software toepassingen zoals websites, web applicaties en mobiele applicaties. Daarnaast bieden ze ook IT consultants aan."
        />
        <title>Anivia | Contact</title>
      </Head>
      <Breadcrumb title="Contact" />
      <section className="py-10">
        <div className="container">
          <div className="max-w-2xl mx-auto text-center">
            <div className="max-w-md mb-8 mx-auto">
              <h2
                className="mt-2 text-4xl font-bold font-heading animate__animated animate__fadeIn"
                data-wow-delay=".1s"
              >
                We zullen <span className="text-blue-500">blij</span> zijn van u
                te horen!
              </h2>
            </div>
            <div>
              <form onSubmit={handleSubmit}>
                <div
                  className="mb-4 animate__animated animate__fadeIn"
                  data-wow-delay=".1s"
                >
                  <input
                    className="w-full p-4 text-xs font-semibold leading-none bg-blueGray-50 rounded outline-none"
                    type="text"
                    placeholder="Volledige naam"
                    name="name"
                    value={formValues.name}
                    onChange={(e) =>
                      setFormValues({ ...formValues, name: e.target.value })
                    }
                    required
                    control-id="ControlID-1"
                  />
                </div>
                <div
                  className="mb-4 animate__animated animate__fadeIn"
                  data-wow-delay=".1s"
                >
                  <input
                    className="w-full p-4 text-xs font-semibold leading-none bg-blueGray-50 rounded outline-none"
                    type="email"
                    placeholder="E-mail"
                    name="email"
                    value={formValues.email}
                    onChange={(e) =>
                      setFormValues({ ...formValues, email: e.target.value })
                    }
                    required
                    control-id="ControlID-2"
                  />
                </div>
                <div
                  className="mb-4 animate__animated animate__fadeIn"
                  data-wow-delay=".1s"
                >
                  <textarea
                    className="w-full h-24 p-4 text-xs font-semibold leading-none resize-none bg-blueGray-50 rounded outline-none"
                    placeholder="Bericht"
                    name="message"
                    value={formValues.message}
                    onChange={(e) =>
                      setFormValues({ ...formValues, message: e.target.value })
                    }
                    required
                    control-id="ControlID-3"
                  ></textarea>
                </div>
                <div className="flex">
                  <button
                    className="py-4 px-8 text-sm text-white font-semibold leading-none bg-blue-500 hover:bg-blue-700 rounded animate__animated animate__fadeIn"
                    type="submit"
                    data-wow-delay=".1s"
                    control-id="ControlID-4"
                  >
                    Versturen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
